import { render } from "./PlayerInfo.vue?vue&type=template&id=f303b27e&scoped=true"
import script from "./PlayerInfo.vue?vue&type=script&lang=js"
export * from "./PlayerInfo.vue?vue&type=script&lang=js"

import "./PlayerInfo.vue?vue&type=style&index=0&id=f303b27e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f303b27e"]])

export default __exports__